<template>
  <!-- <v-img class="top-img" src="" /> -->
  <div
    style="
      min-height: 80px;
      background: linear-gradient(-90deg, #02203d, #001527);
    "
  ></div>
</template>

<script>
export default {};
</script>

<style scoped>
.top-img {
  height: 80vh;
  width: 100%;
  position: absolute;
}
</style>
